import React from "react";
import Button from "../../../components/button";
import PropTypes from "prop-types";
import SectionTitle from "../../../components/section-title";
import data from "../../../data/products.json";
import BlogGrid from "../../home/info-box/details";

const ProductsContainer = ({ classOption }) => {
    return (
        <div className={`feature-section position-relative ${classOption}`}>
            <div className="container custom-container">
                <div className="row g-0 align-items-center">
                    <div className="col-xl-12 col-lg-12 mx-auto mb-5 text-center">
                        <SectionTitle
                            classOption="title-section"
                            subTitle=""
                            title={`<span style="">Why should <span class="text-primary">you borrow from us?</span></span>`}
                            excerptClassOption=""
                            excerpt=""
                        />
                    </div>

                    {/* ✅ FIRST GRID - STATIC CONTENT */}
                    <div className="row col-xl-12 col-lg-12 mx-auto mb-5 text-center">
                        {data.staticProducts?.map((single, key) => (
                            <div key={key} className="col-lg-3 col-sm-4 mb-7">
                                <BlogGrid classOption="" data={single} />
                            </div>
                        ))}
                    </div>

                    {/* ✅ SECOND GRID - FINANCE CARDS */}
                    {data.financeData?.map((group, groupKey) => (
                        <div
                            key={groupKey}
                            className="about-us position-relative pb-5 pt-5"
                        >
                            <h2 className="text-uppercase text-center fw-bold mb-4">
                                {group.category}
                            </h2>
                            <div className="row justify-content-center g-6 mb-5">
                                {group.items.map((item, key) => (
                                    <div
                                        key={key}
                                        className="col-lg-4 col-md-6 d-flex"
                                        id={item.dev_id}
                                        style={{ scrollMargin: "120px" }}
                                    >
                                        <div className="product-div bg-light p-4 rounded-2xl shadow h-100 d-flex flex-column text-start position-relative w-100">
                                            <div className="d-flex align-items-center gap-2 mb-2">
                                                {item.icon && (
                                                    <img
                                                        src={item.icon}
                                                        // alt={`${item.title} icon`}
                                                        alt=""
                                                        style={{
                                                            width: "35px",
                                                            height: "35px",
                                                            borderRadius: "5px",
                                                        }}
                                                    />
                                                )}
                                                <h3 className="fw-bold mb-0">
                                                    {item.title}
                                                </h3>
                                            </div>

                                            {item.watchVideo && (
                                                <span className="badge bg-warning text-dark mb-2">
                                                    Watch Video
                                                </span>
                                            )}

                                            {/* <p className="text-muted mb-2">
                                                Customer segments: <br />
                                                <strong>{item.for}</strong>
                                            </p> */}
                                            <dl>
                                                {item.for && (
                                                    <>
                                                        <dt className="text-muted mb-6">
                                                            Customer segments:
                                                        </dt>
                                                        <dd>{item.for}</dd>
                                                    </>
                                                )}

                                                {item.ticketSize && (
                                                    <>
                                                        <dt className="text-muted mb-1">
                                                            Ticket Size:
                                                        </dt>
                                                        <dd>
                                                            {item.ticketSize}
                                                        </dd>
                                                    </>
                                                )}

                                                {item.tenure && (
                                                    <>
                                                        <dt className="text-muted mb-1">
                                                            Tenure:
                                                        </dt>
                                                        <dd>{item.tenure}</dd>
                                                    </>
                                                )}

                                                {item.businessOperations && (
                                                    <>
                                                        <dt className="text-muted mb-1">
                                                            Business Operations:
                                                        </dt>
                                                        <dd>
                                                            {
                                                                item.businessOperations
                                                            }
                                                        </dd>
                                                    </>
                                                )}

                                                {item.keyDetails?.length >
                                                    0 && (
                                                    <>
                                                        <dt className="text-muted mt-2">
                                                            Benefits:
                                                        </dt>
                                                        <dd>
                                                            <ul className="small mb-3 ps-3">
                                                                {item.keyDetails.map(
                                                                    (
                                                                        detail,
                                                                        i
                                                                    ) => (
                                                                        <li
                                                                            key={
                                                                                i
                                                                            }
                                                                            style={{
                                                                                listStyleType:
                                                                                    "disc",
                                                                                paddingLeft:
                                                                                    "0.75rem",
                                                                            }}
                                                                        >
                                                                            {
                                                                                detail
                                                                            }
                                                                        </li>
                                                                    )
                                                                )}
                                                            </ul>
                                                        </dd>
                                                    </>
                                                )}
                                            </dl>

                                            <div className="col-xl-8 col-lg-8 mx-auto mt-auto text-center">
                                                <h5
                                                    className="fw-bold mb-0"
                                                    id={item.title}
                                                >
                                                    <Button
                                                        classOption="btn btn-xm btn-primary btn-hover-primary"
                                                        text="Apply"
                                                        link={
                                                            [
                                                                "NeoCash Insta",
                                                                "NeoCash Express",
                                                                "SCF Banking",
                                                            ].includes(
                                                                item?.title
                                                            )
                                                                ? "https://insta.neogrowth.in/"
                                                                : "register-form"
                                                        }
                                                        id={item.dev_id}
                                                        ariaLabelledBy={
                                                            item.title
                                                        }
                                                    />
                                                </h5>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

ProductsContainer.propTypes = {
    classOption: PropTypes.string,
};

ProductsContainer.defaultProps = {
    classOption: "section-pb",
};

export default ProductsContainer;
